export default __webpack_public_path__ + "static/media/young-radio-host-at-the-radio-broadcasting-station-2022-10-21-19-43-13-utc.2ca22b3e.jpeg";